<template>
  <div class="business-settings__tree-wrapper">
    <v-list dense class="business-settings__tree">
      <div
        v-for="company in companies"
        :key="company.id"
        class="business-settings__tree-group"
      >
        <v-list-item
          class="business-settings__tree-item business-settings__tree-item--company"
          @click="selectCompany(company)"
          :class="{ 'business-settings__node--active': isActive('company', company), 'business-settings__tree-item--pending': pendingUpdates['company:' + company.id] }"
        >
          <v-list-item-icon class="business-settings__tree-icon">
            <span class="business-settings__tree-icon-badge business-settings__tree-icon-badge--company">
              <v-icon size="22" color="#1D4ED8">mdi-office-building</v-icon>
            </span>
          </v-list-item-icon>
          <v-list-item-content class="business-settings__tree-name">
            <v-list-item-title>{{ company.name }}</v-list-item-title>
          </v-list-item-content>
          <v-progress-circular
            v-if="pendingUpdates['company:' + company.id]"
            indeterminate
            size="14"
            width="2"
            color="#00BCD4"
            class="business-settings__tree-saving-spinner"
          ></v-progress-circular>
          <span class="business-settings__tree-right-group">
            <span class="business-settings__tree-type-label business-settings__tree-type-label--company">Firma</span>
            <v-tooltip bottom max-width="200" color="white" content-class="vpc-tooltip">
              <template v-slot:activator="{ on }">
                <span class="business-settings__tree-add-badge" v-on="on" @click.stop="openAddLocation(company)">
                  <v-icon size="16">mdi-plus</v-icon>
                </span>
              </template>
              <span style="font-size:12px;color:#1e293b;padding:8px 10px;display:block;">Dodaj prodajno mjesto</span>
            </v-tooltip>
            <span class="business-settings__tree-chevron-badge" @click.stop="toggleCompany(company)">
              <v-icon size="18" color="#64748B">{{ expandedCompanies[company.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </span>
          </span>
        </v-list-item>
        <template v-if="expandedCompanies[company.id]">
          <template v-for="location in locationsByCompany[company.id] || []">
            <v-list-item
              :key="'l-' + location.id"
              class="business-settings__tree-item business-settings__tree-item--location"
              @click="selectLocation(company, location)"
              :class="{ 'business-settings__node--active': isActive('location', location), 'business-settings__tree-item--pending': pendingUpdates['location:' + location.id] }"
            >
              <v-list-item-icon class="business-settings__tree-icon">
                <span class="business-settings__tree-icon-badge business-settings__tree-icon-badge--location">
                  <v-icon size="20" color="#F59E0B">mdi-storefront</v-icon>
                </span>
              </v-list-item-icon>
              <v-list-item-content class="business-settings__tree-name">
                <v-list-item-title>{{ location.name }}</v-list-item-title>
              </v-list-item-content>
              <v-progress-circular
                v-if="pendingUpdates['location:' + location.id]"
                indeterminate
                size="14"
                width="2"
                color="#00BCD4"
                class="business-settings__tree-saving-spinner"
              ></v-progress-circular>
              <span class="business-settings__tree-right-group">
                <span class="business-settings__tree-type-label business-settings__tree-type-label--location">Lokacija</span>
                <v-tooltip bottom max-width="200" color="white" content-class="vpc-tooltip">
                  <template v-slot:activator="{ on }">
                    <span class="business-settings__tree-add-badge" v-on="on" @click.stop="openAddRegister(company, location)">
                      <v-icon size="16">mdi-plus</v-icon>
                    </span>
                  </template>
                  <span style="font-size:12px;color:#1e293b;padding:8px 10px;display:block;">Dodaj blagajnu</span>
                </v-tooltip>
                <span class="business-settings__tree-chevron-badge" @click.stop="toggleLocation(company, location)">
                  <v-icon size="16" color="#64748B">{{ expandedLocations[location.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </span>
              </span>
            </v-list-item>
            <template v-if="expandedLocations[location.id]">
              <v-list-item
                v-for="register in registersByLocation[location.id] || []"
                :key="'r-' + register.id"
                class="business-settings__tree-item business-settings__tree-item--register"
                @click="selectRegister(company, location, register)"
                :class="{ 'business-settings__node--active': isActive('cashRegister', register), 'business-settings__tree-item--pending': pendingUpdates['cashRegister:' + register.id] }"
              >
                <v-list-item-icon class="business-settings__tree-icon">
                  <span class="business-settings__tree-icon-badge business-settings__tree-icon-badge--register">
                    <v-icon size="18" color="#00BCD4">mdi-point-of-sale</v-icon>
                  </span>
                </v-list-item-icon>
                <v-list-item-content class="business-settings__tree-name">
                  <v-list-item-title>{{ register.name }}</v-list-item-title>
                </v-list-item-content>
                <v-progress-circular
                  v-if="pendingUpdates['cashRegister:' + register.id]"
                  indeterminate
                  size="14"
                  width="2"
                  color="#00BCD4"
                  class="business-settings__tree-saving-spinner"
                ></v-progress-circular>
                <span class="business-settings__tree-right-group">
                  <span class="business-settings__tree-type-label business-settings__tree-type-label--register">Blagajna</span>
                  <span class="business-settings__tree-right-spacer"></span>
                </span>
              </v-list-item>
              <v-list-item
                v-if="pendingAdds['location:' + location.id]"
                :key="'pending-r-' + location.id"
                class="business-settings__tree-item business-settings__tree-item--register business-settings__tree-item--pending"
              >
                <v-list-item-icon class="business-settings__tree-icon">
                  <span class="business-settings__tree-icon-badge business-settings__tree-icon-badge--register">
                    <v-progress-circular indeterminate size="14" width="2" color="#00BCD4"></v-progress-circular>
                  </span>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="business-settings__tree-pending-text">Dodavanje blagajne...</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
          <v-list-item
            v-if="pendingAdds['company:' + company.id]"
            class="business-settings__tree-item business-settings__tree-item--location business-settings__tree-item--pending"
          >
            <v-list-item-icon class="business-settings__tree-icon">
              <span class="business-settings__tree-icon-badge business-settings__tree-icon-badge--location">
                <v-progress-circular indeterminate size="16" width="2" color="#F59E0B"></v-progress-circular>
              </span>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="business-settings__tree-pending-text">Dodavanje prodajnog mjesta...</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </div>
    </v-list>
    <add-point-of-sale ref="addPointOfSale" @success="onLocationAdded"></add-point-of-sale>
    <add-cash-register ref="addCashRegister" @success="onRegisterAdded"></add-cash-register>
  </div>
</template>

<script>
import { df, auth } from '@/plugins/firebase'
import state from '@/state'
import AddPointOfSale from '@/modules/company/components/AddPointOfSale'
import AddCashRegister from '@/modules/point-of-sale/components/AddCashRegister'

export default {
  name: 'EntityTree',
  components: { AddPointOfSale, AddCashRegister },
  data () {
    return {
      companies: [],
      locationsByCompany: {},
      registersByLocation: {},
      expandedCompanies: {},
      expandedLocations: {},
      active: null,
      unsubscribeCompanies: null,
      locationListeners: {},
      registerListeners: {},
      pendingAdds: {},
      pendingCompanyId: null,
      pendingLocationId: null,
      pendingUpdates: {}
    }
  },
  created () {
    const docRef = df.doc(`user_companies/${auth.currentUser.uid}`)
    this.unsubscribeCompanies = docRef.onSnapshot((doc) => {
      const data = doc.data()
      if (data?.companies) {
        this.companies = Object.keys(data.companies)
          .map(key => data.companies[key])
          .filter(company => company?.resource_status === 'ACTIVE')
          .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'hr'))
        this.companies.forEach(company => {
          if (this.pendingUpdates['company:' + company.id]) {
            this.$delete(this.pendingUpdates, 'company:' + company.id)
          }
          if (this.active && this.active.type === 'company' && this.active.entity.id === company.id) {
            this.active = { type: 'company', entity: company }
            this.$emit('select', { type: 'company', entity: company, company, location: null })
          }
        })
      }
    })
  },
  beforeDestroy () {
    if (this.unsubscribeCompanies) this.unsubscribeCompanies()
    Object.values(this.locationListeners).forEach(unsubscribe => unsubscribe())
    Object.values(this.registerListeners).forEach(unsubscribe => unsubscribe())
  },
  methods: {
    isActive (type, entity) {
      return this.active && this.active.type === type && this.active.entity.id === entity.id
    },
    selectCompany (company) {
      this.active = { type: 'company', entity: company }
      this.$emit('select', { type: 'company', entity: company, company, location: null })
      this.expandCompany(company)
    },
    ensureLocationsLoaded (company) {
      if (this.expandedCompanies[company.id] && !this.locationsByCompany[company.id]) {
        const query = df.collection('locations')
          .where('company_id', '==', company.id)
          .where('status', '==', 'OK')
        this.locationListeners[company.id] = query.onSnapshot((snapshot) => {
          const locations = snapshot.docs
            .map(doc => doc.data())
            .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))
          this.$set(this.locationsByCompany, company.id, locations)
          if (this.pendingAdds['company:' + company.id]) {
            this.$delete(this.pendingAdds, 'company:' + company.id)
          }
          locations.forEach(location => {
            if (this.pendingUpdates['location:' + location.id]) {
              this.$delete(this.pendingUpdates, 'location:' + location.id)
            }
            if (this.active && this.active.type === 'location' && this.active.entity.id === location.id) {
              this.active = { type: 'location', entity: location }
              this.$emit('select', { type: 'location', entity: location, company, location })
            }
          })
        })
      }
    },
    toggleCompany (company) {
      this.$set(this.expandedCompanies, company.id, !this.expandedCompanies[company.id])
      this.ensureLocationsLoaded(company)
    },
    expandCompany (company) {
      if (!this.expandedCompanies[company.id]) {
        this.$set(this.expandedCompanies, company.id, true)
      }
      this.ensureLocationsLoaded(company)
    },
    selectLocation (company, location) {
      this.active = { type: 'location', entity: location }
      this.$emit('select', { type: 'location', entity: location, company, location })
      this.expandLocation(company, location)
    },
    ensureRegistersLoaded (company, location) {
      if (this.expandedLocations[location.id] && !this.registersByLocation[location.id]) {
        const query = df.collection('cash_registers')
          .where('location_id', '==', location.id)
          .where('status', '==', 'OK')
        this.registerListeners[location.id] = query.onSnapshot((snapshot) => {
          const registers = snapshot.docs
            .map(doc => doc.data())
            .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))
          this.$set(this.registersByLocation, location.id, registers)
          if (this.pendingAdds['location:' + location.id]) {
            this.$delete(this.pendingAdds, 'location:' + location.id)
          }
          registers.forEach(register => {
            if (this.pendingUpdates['cashRegister:' + register.id]) {
              this.$delete(this.pendingUpdates, 'cashRegister:' + register.id)
            }
            if (this.active && this.active.type === 'cashRegister' && this.active.entity.id === register.id) {
              this.active = { type: 'cashRegister', entity: register }
              this.$emit('select', { type: 'cashRegister', entity: register, company, location })
            }
          })
        })
      }
    },
    toggleLocation (company, location) {
      this.$set(this.expandedLocations, location.id, !this.expandedLocations[location.id])
      this.ensureRegistersLoaded(company, location)
    },
    expandLocation (company, location) {
      if (!this.expandedLocations[location.id]) {
        this.$set(this.expandedLocations, location.id, true)
      }
      this.ensureRegistersLoaded(company, location)
    },
    selectRegister (company, location, register) {
      this.active = { type: 'cashRegister', entity: register }
      this.$emit('select', { type: 'cashRegister', entity: register, company, location })
    },
    openAddLocation (company) {
      state.setCurrentCompany(company)
      this.expandCompany(company)
      this.pendingCompanyId = company.id
      this.$refs.addPointOfSale.open()
    },
    openAddRegister (company, location) {
      state.setCurrentCompany(company)
      state.setPointOfSale(location)
      this.expandLocation(company, location)
      this.pendingLocationId = location.id
      this.$refs.addCashRegister.open()
    },
    onLocationAdded () {
      if (this.pendingCompanyId) {
        const companyId = this.pendingCompanyId
        this.$set(this.pendingAdds, 'company:' + companyId, true)
        setTimeout(() => {
          this.$delete(this.pendingAdds, 'company:' + companyId)
        }, 15000)
      }
      this.$emit('entity-added')
    },
    onRegisterAdded () {
      if (this.pendingLocationId) {
        const locationId = this.pendingLocationId
        this.$set(this.pendingAdds, 'location:' + locationId, true)
        setTimeout(() => {
          this.$delete(this.pendingAdds, 'location:' + locationId)
        }, 15000)
      }
      this.$emit('entity-added')
    },
    markPendingUpdate (type, id) {
      const key = type + ':' + id
      this.$set(this.pendingUpdates, key, true)
      setTimeout(() => {
        this.$delete(this.pendingUpdates, key)
      }, 15000)
    }
  }
}
</script>

<style scoped>
.business-settings__tree-group {
  margin-bottom: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  border: 1px solid #E5E7EB;
  border-radius: 14px;
  background: #FAFBFC;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.business-settings__tree-group:last-child {
  margin-bottom: 0;
}
.business-settings__tree-item {
  min-height: 0;
}
.business-settings__tree-item--company {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 12px;
  padding-right: 12px;
  margin: 0 8px;
}
.business-settings__tree-item--location {
  font-size: 13px;
  font-weight: 400;
  color: #374151;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 18px;
  padding-right: 12px;
  margin-left: 12px;
  margin-right: 8px;
  border-left: 1px solid #E5E7EB;
}
.business-settings__tree-item--register {
  font-size: 12px;
  color: #4B5563;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 36px;
  padding-right: 12px;
  margin-left: 12px;
  margin-right: 8px;
  border-left: 1px solid #E5E7EB;
}
.business-settings__tree-icon {
  align-self: center !important;
  display: flex !important;
  align-items: center !important;
  height: auto !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-right: 14px !important;
  min-width: 0 !important;
}
.business-settings__tree-icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.10),
    inset 0 1px 1px rgba(255, 255, 255, 0.5),
    inset 0 -1px 1px rgba(0, 0, 0, 0.05);
}
.business-settings__tree-icon-badge--company {
  background: rgba(29, 78, 216, 0.12);
}
.business-settings__tree-icon-badge--location {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: rgba(245, 158, 11, 0.12);
}
.business-settings__tree-icon-badge--register {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(0, 188, 212, 0.12);
}
.business-settings__tree-chevron-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: #F1F5F9;
  transition: background-color 0.15s ease;
}
.business-settings__tree-chevron-badge:hover {
  background: #E5E7EB;
}
.business-settings__tree-add-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  margin-right: 6px;
  color: #94A3B8;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, background-color 0.15s ease, color 0.15s ease;
}
.business-settings__tree-item--company:hover .business-settings__tree-add-badge,
.business-settings__tree-item--location:hover .business-settings__tree-add-badge {
  opacity: 1;
  pointer-events: auto;
}
.business-settings__tree-add-badge:hover {
  background: rgba(0, 188, 212, 0.12);
  color: #00BCD4;
}
.business-settings__node--active {
  background-color: rgba(0, 188, 212, 0.14);
  color: #0E4650;
  font-weight: 700;
  border-radius: 12px;
  box-shadow: inset 0 0 0 1.5px #00BCD4;
}
.vpc-tooltip { background: #ffffff !important; box-shadow: 0 4px 16px rgba(0,0,0,0.10) !important; border: 1.5px solid #00BCD4 !important; border-radius: 10px !important; padding: 0 !important; }
.business-settings__tree-item--pending {
  opacity: 0.7;
  pointer-events: none;
}
.business-settings__tree-pending-text {
  font-style: italic;
  color: #94A3B8 !important;
}
.business-settings__tree-saving-spinner {
  flex-shrink: 0;
  margin-right: 8px;
}
.business-settings__tree-name {
  min-width: 0;
  flex: 1 1 auto;
}
.business-settings__tree-name >>> .v-list-item__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.business-settings__tree-right-group {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}
.business-settings__tree-right-spacer {
  width: 60px;
  flex-shrink: 0;
}
.business-settings__tree-type-label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  white-space: nowrap;
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 6px;
  width: 68px;
  text-align: center;
}
.business-settings__tree-type-label--company {
  background: #F3F4F6;
  color: #6B7280;
}
.business-settings__tree-type-label--location {
  background: #FFFBEB;
  color: #D97706;
}
.business-settings__tree-type-label--register {
  background: #ECFEFF;
  color: #0891B2;
}
.business-settings__node--active .business-settings__tree-type-label {
  background: rgba(255, 255, 255, 0.6);
  color: #0E7490;
}
</style>
